import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { addFeedback } from '../../database/firebase';
import { StarIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const FeedbackForm = ({ reportId, onFeedbackSubmitted }) => {
  const [feedback, setFeedback] = useState({
    content: '',
    rating: 5,
    type: 'general',
  });
  const { currentUser } = useAuth();

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await addFeedback({
        ...feedback,
        reportId,
        userId: currentUser.uid,
        createdAt: new Date().toISOString(),
      });
      setFeedback({ content: '', rating: 5, type: 'general' });
      if (onFeedbackSubmitted) onFeedbackSubmitted();
    } catch (error) {
      alert('Error submitting feedback. Please try again.');
    }
  };

  return (
    <div className="rounded-xl border border-black/20 bg-white p-4 shadow-sm md:p-6">
      <div className="mb-5 flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-600">
          <ChatBubbleLeftRightIcon className="h-5 w-5 text-white" />
        </div>
        <div>
          <h3 className="text-base font-bold text-black md:text-lg">Provide Feedback</h3>
          <p className="text-xs text-black/70 md:text-sm">Share your thoughts and suggestions</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4 md:space-y-5">
        <div>
          <label className="mb-2 block text-sm font-semibold text-black">Feedback Type</label>
          <select
            value={feedback.type}
            onChange={e => setFeedback(prev => ({ ...prev, type: e.target.value }))}
            className="w-full rounded-lg border border-black/20 bg-white px-4 py-2.5 text-black shadow-sm transition-colors focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/20"
          >
            <option value="general">General Feedback</option>
            <option value="improvement">Areas for Improvement</option>
            <option value="praise">Praise & Recognition</option>
          </select>
        </div>

        <div>
          <label className="mb-2 block text-sm font-semibold text-black">Rating</label>
          <div className="mb-2 flex items-center gap-1">
            {[1, 2, 3, 4, 5].map(star => (
              <button
                key={star}
                type="button"
                onClick={() => setFeedback(prev => ({ ...prev, rating: star }))}
                className={`transition-colors ${
                  star <= feedback.rating
                    ? 'text-amber-500 hover:text-amber-600'
                    : 'text-black/30 hover:text-black/50'
                }`}
              >
                <StarIcon className="h-5 w-5" />
              </button>
            ))}
          </div>
          <div className="flex justify-between text-[10px] text-black/60 md:text-xs">
            <span>Poor</span>
            <span>Excellent</span>
          </div>
        </div>

        <div>
          <label className="mb-2 block text-sm font-semibold text-black">Feedback Content</label>
          <textarea
            value={feedback.content}
            onChange={e => setFeedback(prev => ({ ...prev, content: e.target.value }))}
            rows="4"
            placeholder="Share your detailed feedback, suggestions, or observations..."
            className="w-full rounded-lg border border-black/20 bg-white px-4 py-2.5 text-black shadow-sm transition-colors focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/20"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 md:px-5 md:text-base"
        >
          Submit Feedback
        </button>
      </form>
    </div>
  );
};

export default FeedbackForm;
